import './index.css'
export default function Footer () {
    return(
        <div className="footer">
          Developed by <a href="https://github.com/Hat52" target="_blank" rel="noreferrer" data-replace="Hamza Ali"><span>Hamza Ali</span></a>
        </div>
    )
}